import React from "react";

const FilterArticle = () => {
  return <React.Fragment></React.Fragment>;
};

export default FilterArticle;
